import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./breadcrumb.css";

const BreadcrumbBanner = ({ title, backgroundImage }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <div
      className="breadcrumb-banner"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="breadcrumb-content">
        <h1>{title}</h1>
        <p className="breadcrumb-trail">
          <Link to="/">Home</Link>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const formattedName = name.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());

            return (
              <span key={index}>
                {" "}
                &raquo;{" "}
                {isLast ? (
                  <span>{formattedName}</span>
                ) : (
                  <Link to={routeTo}>{formattedName}</Link>
                )}
              </span>
            );
          })}
        </p>
      </div>
    </div>
  );
};

export default BreadcrumbBanner;
